// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhe_a bic_bi"};